import { FiMinus, FiTrash2 } from "react-icons/fi"

import {
   HeaderActions,
   HeaderButton,
   HeaderContainer,
   HeaderLeft,
   HeaderSubtitle,
   HeaderTitle,
   OnlineDot,
} from "./styles"

const ChatHeader = ({ onClose, onClear }) => {
   return (
      <HeaderContainer>
         <HeaderLeft>
            <div>
               <HeaderTitle>GoTruck Assistant</HeaderTitle>
               <HeaderSubtitle>
                  <OnlineDot /> Online
               </HeaderSubtitle>
            </div>
         </HeaderLeft>
         <HeaderActions>
            <HeaderButton onClick={onClear} title="Clear chat">
               <FiTrash2 />
            </HeaderButton>
            <HeaderButton onClick={onClose} title="Minimize">
               <FiMinus />
            </HeaderButton>
         </HeaderActions>
      </HeaderContainer>
   )
}

export default ChatHeader
